import React, { FC, HTMLAttributes } from 'react';

import classNames from '../../helpers/classNames';
import useTranslate from '../../hooks/useTranslate';
import FormattedCurrency from '../FormattedCurrency/FormattedCurrency';
import styles from './AccommodationItem.module.scss';

interface AccommodationItemTotalProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  value: number;
  currencyName: string;
  items: Record<string, number>;
  numberOfGuests?: number;
}

export const AccommodationItemTotal: FC<AccommodationItemTotalProps> = props => {
  const { value, currencyName, items, numberOfGuests, className } = props;
  const { translate } = useTranslate();

  return (
    <div className={classNames(className, styles.itemBody)}>
      <div>
        <div className={styles.title}>{String(translate('accommodation.total'))}</div>
        <ul className="list-unstyled small text-muted px-4">
          {!!numberOfGuests && (
            <li>{translate('accommodation.total-guests', { number: numberOfGuests })}</li>
          )}
          {Object.entries(items).map(([key, quantity]) => (
            <li key={key}>
              {quantity > 0
                ? translate('accommodation.total-item', {
                    item: key,
                    number: quantity,
                  })
                : key}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex-shrink-0">
        <FormattedCurrency value={value} name={currencyName} className={styles.price} />
      </div>
    </div>
  );
};
